import React, { useMemo, useRef, useEffect } from "react";
import useObtenerTraducciones from "../../js/translations/useObtenerTraducciones";
import { useQueryParams } from "../../hooks/useQueryParams";
import { PLANES_DATA } from "../planCasa/data/planes";
import useObtenerSubsecciones from "../../js/translations/useObtenerSubsecciones";
import _ from "lodash";
import { LECTURA_DATA } from "../planCasa/data/lectura-data";
import { CURSOS_DATA } from "../planCasa/data/cursos";
import { useTranslations } from "../../hooks/use-translations";

const CATEGORIES = {
	1: "1", // libro favorito, mi colección,
	2: "2", // planes de lecturas
	3: "3", // cursos
};

/**
 * Componente que muestra la sección de transacción aprobada.
 */
export const ApprovedTransaction = () => {
	const { isReady, textosSeccion: transaccion } = useObtenerTraducciones("resultadoTransaccion");
	const { textosSubSecciones: storeTexts } = useObtenerSubsecciones("tienda_makemake");
	const textosAcademia = useTranslations({ section: "academia" });

	const params = useQueryParams();
	const productId = params.get("productId");
	const category = params.get("category");

	const titleRef = useRef();

	useEffect(() => {
		if (isReady && titleRef.current) {
			titleRef.current.focus();
		}
	}, [isReady]);

	const data = useMemo(() => {
		if (category === CATEGORIES[1]) {
			const plans = [...PLANES_DATA.trimestral, ...PLANES_DATA.semestral];
			const plan = plans.find((plan) => plan?.id?.includes(productId));
			if (!plan) return null;
			return {
				productId,
				productName:
					_.get(storeTexts, plan?.nombre?.translationPath) || plan?.nombre?.default,
				price: plan?.precio?.usd,
			};
		} else if (category === CATEGORIES[2]) {
			const readingPlans = [...LECTURA_DATA];
			const readingPlan = readingPlans.find((plan) => plan?.id?.includes(productId));
			if (!readingPlan) return null;
			return {
				productName:
					_.get(storeTexts, readingPlan?.nombre?.translationPath) ||
					readingPlan?.nombre?.default,
				price: PLANES_DATA.semestral.find((plan) => plan?.id === 'lecturas-makemake')?.precio?.usd,
			};
		} else if (category === CATEGORIES[3]) {
			const cursos = [...CURSOS_DATA];
			const curso = cursos.find((curso) => curso?.id?.includes(productId));
			if (!curso) return null;
			return {
				productName:
					_.get(textosAcademia, curso?.nombre?.translationPath) || curso?.nombre?.default,
				price: curso?.precio?.usd,
			};
		} else {
			return null;
		}
	}, [productId, category, storeTexts, textosAcademia]);

	return (
		<>
			<div
				className="surface--bg onbackground-primary--color main-container mm-redimir"
				id="demo-transaccion"
			>
				<div className="container main-content">
					{isReady && (
						<div className="p-lg-3 pl-lg-5">
							<div className="col-lg-10 mx-auto pt-3 pb-4">
								<div id="contact-data">
									<h1
										ref={titleRef}
										tabIndex={-1}
										className="mm-redimir_title mb-5 text-center">
										{transaccion?.titulo || "Resultado de transacción"}
									</h1>

									<>
										<div
											className="transaccion-container"
											id="transaccion-acepted"
											role="status"
											aria-live="polite"
										>
											<div
												className={`mb-4 transaccion-status acepted p-4 text-center`}
											>
												<p
													role="text"
													aria-label={storeTexts?.resultadoTransaccion?.accesibilidad?.successful || "Tu transacción fue exitosa. En unas horas recibirás tu usuario y contraseña en tu correo."}
													dangerouslySetInnerHTML={{
														__html:
															transaccion?.transaccion_aceptada ||
															"Tu transacción fue éxitosa.<br /> En unas horas te llegará tu usuario y contraseña al correo que registraste al momento de la compra en nuestra plataforma.",
													}}
												></p>
											</div>
										</div>

										{productId && category && data && (
											<>
												<h2 className="text-center mb-3">
													<strong>
														{transaccion?.informacion ||
															"Información de la transacción"}
													</strong>
												</h2>
												<div id="informacion-orden">
													<div className="mx-auto px-0 col-lg-10 table-responsive">
														<table className="table">
															<thead className="thead-dark">
																<tr></tr>
															</thead>
															<caption className="sr-only">
																{transaccion?.informacion || "Información de la transacción"}
															</caption>
															<tbody
																id="response-table"
																className="w-100"
															>
																<tr>
																	<th scope="row">
																		{transaccion?.producto ||
																			"Producto"}
																	</th>
																	<td>{data?.productName}</td>
																</tr>
																<tr>
																	<th scope="row">
																		{transaccion?.total ||
																			"Total"}
																	</th>
																	<td aria-label={`${transaccion?.total ||
																			"Total"} ${data?.price}`}>USD ${data?.price}</td>
																</tr>
															</tbody>
														</table>
													</div>
												</div>
											</>
										)}

										<div className="py-4 text-center">
											<p>
												{transaccion?.puedes ||
													"Puedes contactarte con nosotros si tienes alguna duda"}
											</p>
											<p>
												<span className="bold">
													{transaccion?.correo || "Correo:"}
												</span>{" "}
												contacto@makemake.com.co
											</p>
											<p>
												<span className="bold">
													{transaccion?.whatsapp || "Whatsapp:"}
												</span>{" "}
												57 350 236 7037
											</p>
										</div>

										{!data && (
											<p role="alert" className="sr-only">
												{storeTexts?.resultadoTransaccion?.accesibilidad?.could_not || 'No se pudo obtener la información de la transacción.'}
											</p>
										)}
									</>
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
		</>
	);
};
